import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/etsy-seller-protection';

export default function Example() {
  return (
    <>
      <Head>
        <title>Etsy Seller Protection: What It Is and How It Works</title>
        <meta
          name='description'
          content='As an Etsy seller, you want to know that your items are protected in the event of a dispute. That’s where Etsy Seller Protection comes in. Here’s what it is and how it works.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/etsy-seller-protection' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/etsy-seller-protection' />
        <meta property='og:title' content='Etsy Seller Protection: What It Is and How It Works' />
        <meta
          property='og:description'
          content='As an Etsy seller, you want to know that your items are protected in the event of a dispute. That’s where Etsy Seller Protection comes in. Here’s what it is and how it works.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-10-24T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-10-24T00:00:00-00:00' />
        <meta property='article:tag' content='Etsy' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
